import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'have_there_been_any_cases_of_physical_verbal_psychological_hara'

export const dataPointDefinition = {
  retracedId: 'have_there_been_any_cases_of_physical_verbal_psychological_hara',
  name: 'Have there been any cases of physical, verbal, psychological harassment, violence or abuse?',
  description:
    'For example, this could include hitting, pushing, or throwing things; restricting access to food, water or toilets; threatening or shouting at workers; or publicly scolding workers in a degrading manner. Restricting reasonable access to water or toilets in this context is different from inadequate access in general. In this case, it is targeted to certain workers and/or violates human rights or dignity.\r\r\n\r\r\nInclude any case of physical, verbal, psychological harassment or abuse no matter who at the facility was being harassed/abused and no matter who was engaging in the harassment/abuse. This question covers harassment or abuse  that takes place at the workplace, facility premises, in communications, in employer-provided accommodation, and/or when commuting to and from work.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hb-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10070,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
